module.exports = __webpack_public_path__ + "static/media/Hallesche.8a6fdebf.svg";